import { formatNumber } from "../../shared/versions";
import { Button } from "@/components/ui/button";

/** Ortak sayfalama (ui.md §4.2): "Önceki · Sayfa n / m · Sonraki". Sayfa sayısı API'nin total ve pageSize'ından gelir. */
export function Pager({ page, total, pageSize, onPage, label = "Sayfalama", showTotal = false }: {
  page: number; total: number; pageSize: number; onPage: (p: number) => void; label?: string; showTotal?: boolean;
}) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  return (
    <nav aria-label={label} className="flex items-center gap-3 text-sm">
      <Button size="sm" variant="outline" aria-label="Önceki sayfa" disabled={page <= 1} onClick={() => onPage(page - 1)}>Önceki</Button>
      <span aria-live="polite" className="tabular-nums">Sayfa {formatNumber(page)} / {formatNumber(pages)}{showTotal && ` · ${formatNumber(total)} kayıt`}</span>
      <Button size="sm" variant="outline" aria-label="Sonraki sayfa" disabled={page >= pages} onClick={() => onPage(page + 1)}>Sonraki</Button>
    </nav>
  );
}
